/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Detail_InfoInputs */

const vi_vehicle_detail_info = /** @type {(inputs: Vehicle_Detail_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin xe`)
};

/**

* @param {Vehicle_Detail_InfoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_detail_info = /** @type {((inputs?: Vehicle_Detail_InfoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Detail_InfoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_detail_info(inputs)
});